import { render, staticRenderFns } from "./ContentList.vue?vue&type=template&id=1406a7a4&scoped=true"
import script from "./ContentList.vue?vue&type=script&lang=js"
export * from "./ContentList.vue?vue&type=script&lang=js"
import style0 from "./ContentList.vue?vue&type=style&index=0&id=1406a7a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1406a7a4",
  null
  
)

export default component.exports